import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { } from '@azure/msal-angular';
import { environment } from '@env/environment';
import { OktaAuthModule, OktaConfig } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { AuthGuard } from './guards/auth.guard';
import { PreAuthGuard } from './guards/pre-auth.guard';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { AUTHENTICATION_CONFIGURATION_NAMES } from './services/auth/authenticationConfigNames';

let providers: Array<any> = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
  PreAuthGuard,
  AuthGuard,
];
const imports: Array<any> = [];

const bootstrapComponents: Array<any> = [];

const authSetup = environment.auth.reduce(
  (a, v) => ({ ...a, [v.authConfigName]: v }),
  {},
);


if (
  authSetup[AUTHENTICATION_CONFIGURATION_NAMES.OKTA] &&
  authSetup[AUTHENTICATION_CONFIGURATION_NAMES.OKTA].enabled
) {
  const oktaAuth =
    window.location.search &&
      window.location.search.includes('login=esqep') &&
      authSetup[AUTHENTICATION_CONFIGURATION_NAMES.OKTA].sqeptechOpenIdIssuer
      ? new OktaAuth({
        issuer:
          authSetup[AUTHENTICATION_CONFIGURATION_NAMES.OKTA]
            .sqeptechOpenIdIssuer,
        clientId:
          authSetup[AUTHENTICATION_CONFIGURATION_NAMES.OKTA].sqeptechClientId,
        redirectUri: window.location.origin + '/login/callback',
      })
      : new OktaAuth({
        issuer:
          authSetup[AUTHENTICATION_CONFIGURATION_NAMES.OKTA].openIdIssuer,
        clientId: authSetup[AUTHENTICATION_CONFIGURATION_NAMES.OKTA].clientId,
        redirectUri: window.location.origin + '/login/callback',
      });
  const moduleConfig: OktaConfig = { oktaAuth };
  imports.push(OktaAuthModule.forRoot(moduleConfig));
}

@NgModule({
  declarations: [],
  imports: imports,
  providers: providers,
  bootstrap: bootstrapComponents,
})
export class AuthModule { }
